export default "__VITE_ASSET__BpIw9Bq5__"